import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAuSZsNYy8WYmzWAhwOskGmcskW6PcoeJs",
  authDomain: "indecx-launcher-228b1.firebaseapp.com",
  databaseURL: "https://indecx-launcher-228b1-default-rtdb.firebaseio.com",
  projectId: "indecx-launcher-228b1",
  storageBucket: "indecx-launcher-228b1.firebasestorage.app",
  messagingSenderId: "950567985865",
  appId: "1:950567985865:web:da546530c856035086e318",
  measurementId: "G-P5Z3P7W2HY"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { database, auth, storage }; 